import script from "./NewsPageBodyPostFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPostFooter.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPostFooter.vue?vue&type=style&index=0&id=5b9b0bd6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9b0bd6"]])

export default __exports__